// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__Mzkv-","title":"AfterFrontImage_title__11gVX"};